<div class="panel-tile">
    {{pageTitle}}
</div>
<!-- <div class="col-md-121">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Profile</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Contact</a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">test</div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">hr</div>
        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
      </div>
</div> -->

<div class="panel-padding">
    <div class="panel-tile">
        <h3 i18n>Steps</h3>
    </div>
    

<div class="ui-widget-header w-widget-table panel-widget">
        <div class="tab-integration">
            <div class="tabview-tabs">
            <p-tabView>

                <p-tabPanel leftIcon="icon md-edit" header="Dealer Info">
                    <div class="tab-integration">
                       <h3>Dealer Info</h3>
                       <p>The story begins as Don Vito Corleone, the head of a New York Mafia family, overseeshis daughter's wedding. His beloved son
                ichael has just come home from the war, but does not intend to become part of his father's business. T hrough
                Michael's life the nature of the family business becomes clear. The business of the family is just like the
                head of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever
                anything stands against the good of the family.</p>
                    </div>
                </p-tabPanel>
                <p-tabPanel leftIcon="icon md-view-quilt" header="DMS Enrollments">
                    <div class="tab-integration">
                        <h3>DMS Enrollments</h3>
                        
                    </div>
                </p-tabPanel>
                <p-tabPanel leftIcon="icon md-accounts-alt" header="Subscribe">
                    <div class="tab-integration">
                      <h3>Subscribe</h3>
                      <p>After a break of more than 15 years, director Francis Ford Coppola and writer Mario Puzo returned to the well for this third
                and final story of the fictional Corleone crime family. Two decades have passed, and crime kingpin Michael
                Corleone, now divorced from his wife Kay has nearly succeeded in keeping his promise that his family would
                one day be completely legitimate.</p>
                    </div>
                </p-tabPanel>
                 <p-tabPanel leftIcon="icon md-file-text" header="Tracking Log">
                    <div class="tab-integration">
                        <h3>Tracking Log</h3>
                        <p>The child Vito flees his Sicilian village for America after the
                local Mafia kills his family. Vito struggles to make a living, legally or illegally, for his wife and growing
                brood in Little Italy, killing the local Black Hand Fanucci after he demands his customary cut of the tyro's
                business. With Fanucci gone, Vito's communal stature grows. The business of the family is just like the
                head of the family, kind and benevolent to those who give respect, but given to ruthless violence whenever
                anything stands against the good of the family.</p>
                    </div>
                </p-tabPanel>
            </p-tabView>
            </div>
        </div>
    </div>
</div>
